import { render, staticRenderFns } from "./ViewSaleInvoices.vue?vue&type=template&id=02b6cae6&scoped=true&"
import script from "./ViewSaleInvoices.vue?vue&type=script&lang=js&"
export * from "./ViewSaleInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b6cae6",
  null
  
)

export default component.exports